export interface VideoStoreAccessLog
{
    videoId:number,
    email:string,
    provinceCode:string,
}

export function VideoStoreAccessLogDefaultValues():VideoStoreAccessLog
{
    return{videoId:0,email:'',provinceCode:''}
}